// extracted by mini-css-extract-plugin
module.exports = {"titlePanel":"room_titlePanel__3D532","fadeon":"room_fadeon__1ZBE3","room":"room_room__1dLvN"};